export default {
  oops: 'Uops!',
  validOrigin: 'Selecione um local de partida válido',
  validDestination: 'Selecione um destino válido',
  validOutboundDate: 'Selecione uma data de partida válida',
  validReturnDate: 'Selecione uma data de retorno válida',
  validChildAges: 'Selecione as idades de todas as crianças',
  oneChild: 'Apenas é permitida 1 criança (de 0-2 anos) por cada adulto',
}
